module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "popup--inner"
  }, [_c('h2', {
    staticClass: "popup--title"
  }, [_vm._v("\n            Deleting " + _vm._s(_vm.resource) + " is permanent\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "popup--paragraph"
  }, [_vm._v("\n            Once deleted, " + _vm._s(_vm.resource) + " cannot be reverted. Think twice.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "popup--buttons"
  }, [_c('button', {
    staticClass: "popup--buttons-item btn btn_grey btn_stroke",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                Cancel\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "popup--buttons-item btn btn_green",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("\n                Confirm\n            ")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c7aed06c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7aed06c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/modal_confirm.vue
// module id = 458
// module chunks = 1